app.controller('SidebarCtrl', ['$scope', 'ContactService', 'AuthService', 'Site', 'HasChildView', 'Contacts', function($scope, ContactService, AuthService, Site, HasChildView, Contacts) {
  $scope.mainContact = ContactService.getMainContact(Contacts);
  $scope.user = AuthService.getAuthenticatedUser().user || {};
  $scope.currentSite = Site;
  $scope.childView = HasChildView;
}]);
